/**
 *
 *  USER BASED FILTERS
 *
 */

/* isProviderActive uses cache.batch_claim_is_provider_active() in DB
   the other filters are only meant for query performance
   isProviderActive ensures:
    documentationClaimState: in 'AWAITING_UPLOAD', 'DOCUMENTS_RECEIVED'
    invoiceClaimState: 'NOT_PAID'
    workflowClaimState: in 'TO_DO', 'IN_PROGRESS', 'COMPLETED'
*/
const claimIsProviderActiveFilter = {
  batchClaimStateById: {
    isProviderActive: { equalTo: true },
  },
};

const claimIsAssignedToUserFilter = {
  batchClaimAssigneesExist: true,
  isAssignedToQueryingUser: { equalTo: true },
};

/**
 *
 *  STATUS BASED FILTERS
 *  IS ACTIVE, OPEN, REVIEWED, AWAITING DOCS, ETC....
 *
 */

const isRealized = {
  invoiceClaimStatesExist: true,
  batchClaimStateById: {
    isRealized: { equalTo: true },
  },
};

export { claimIsProviderActiveFilter, claimIsAssignedToUserFilter, isRealized };
